import { render } from "./HomeTailComponent.vue?vue&type=template&id=64a3c6be"
import script from "./HomeTailComponent.vue?vue&type=script&lang=js"
export * from "./HomeTailComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/nodebee_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__